import React from 'react';
import { Flex } from '@dna/react';
import { HeaderBar } from './features/header-bar/HeaderBar';

export const ApplicationLayout=(props:{children:any})=>{
    let {children}=props;
    return (
        <Flex 
            css={{
                gap:0,
                minHeight:"100vh"
            }}

        >
        
        <HeaderBar/>
        
        {children}
        
    </Flex>
    );

}